import { render, staticRenderFns } from "./MatchInfoResultsTennis.vue?vue&type=template&id=4c15d426&scoped=true"
import script from "./MatchInfoResultsTennis.vue?vue&type=script&lang=js"
export * from "./MatchInfoResultsTennis.vue?vue&type=script&lang=js"
import style0 from "./MatchInfoResultsTennis.vue?vue&type=style&index=0&id=4c15d426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c15d426",
  null
  
)

export default component.exports